import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import FormattedMessage from 'I18n/components/FormattedMessage';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NotFound = () => {
  return /*#__PURE__*/_jsxs(ErrorMessage, {
    type: "notFound",
    children: [/*#__PURE__*/_jsx(Paragraph, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.notFound.description"
      })
    }), /*#__PURE__*/_jsx(RouterLink, {
      to: "/",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.notFound.goBackToAcademy"
      })
    })]
  });
};
export default NotFound;